<form [formGroup]="TieForm" (ngSubmit)="Submit(TieForm)" novalidate>
    <h1 mat-dialog-title>Decide Tie Winner</h1>
    <div mat-dialog-content>
        <p>
            There are {{Nominees.length}} nominees tied for this judging round.
            Since you elected to perform a special override, please choose the ranking by using the available drop-downs.
        </p>

        <div>
            <p>You must schedule a tie-breaking round by specifying the starting and ending dates/times below.</p>

            <table>
                <thead class="primarybackground500">
                    <tr>
                        <th>Nominee #</th>
                        <th>Name</th>
                        <th>Site Name</th>
                        <th>Rank</th>
                    </tr>
                </thead>
                <tbody formArrayName="RankingsList">
                    <tr *ngFor="let n of Nominees; let i = index" [formGroupName]="i">
                        <td>{{n?.NominationID}}</td>
                        <td>{{n?.FirstName}} {{n?.LastName}}</td>
                        <td>{{n?.SiteName}}</td>
                        <td>
                            <mat-form-field appearance="outline">
                                <mat-select formControlName="Rank" placeholder="Select ranking...">
                                    <mat-option *ngFor="let r of AvailableRanks" [value]="r">{{r}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="TieForm.get('RankingsList')?.at(i).get('Rank')?.hasError('required')">required</mat-error>
                                <mat-hint *ngIf="DuplicateExists(i)">Duplicate Rank</mat-hint>
                            </mat-form-field>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div mat-dialog-actions>
        <button mat-raised-button type="button" [color]="'accent'" (click)="CancelHandler()">Cancel</button>
        <button mat-raised-button type="submit" [color]="'primary'">Submit</button>
    </div>
</form>
